import * as React from 'react';
import {
	getCurrency,
	getEntityById,
	nullSafeGet,
	nullSafeGetOrElse,
	onRowWithRangeSelection,
} from '../../utils/DataAccessUtils';
import {
	getInvoiceRestCrudThunksFromPath,
	getInvoiceRev,
	getInvoiceSubmittedAt,
	getInvoiceSubmittedContact,
	getRecordRev,
} from '../invoice_utilities/InvoiceUtilities';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';
import { Content } from 'antd/es/layout/layout';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Row, Col, Table, Button } from 'antd';
import DateTimeHover from '../date_time_component/DateTime';
import { UserName } from '../name_component/user/UserNameComponent';
import { CustomCurrencyDisplay } from '../custom_currency_display/CustomCurrencyDisplay';
import InvoicePageDisplay from '../invoice_page_display/InvoicePageDisplay';
import { getQuoteSubmittedAt, getQuoteSubmittedContact } from '../quote_utils/QuoteUtils';
import { DownOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

const InvoiceDetailRevisionsPage = ({ invoice, getInvoice, match }) => {
	const invoiceId = useMemo(() => nullSafeGet('params.id', match), [match]);
	const [expandedRowKeys, setExpandedRowKeys] = useState(new Set());

	const invoiceItems = useMemo(
		() =>
			nullSafeGetOrElse('revisionChanges', invoice, [])
				.map((rev, i) => getRecordRev(invoice, i + 1))
				.sort((a, b) => b.revision - a.revision),
		[invoice]
	);

	const toggleExpandByRevision = (revision) => {
		expandedRowKeys.has(revision)
			? expandedRowKeys.delete(revision)
			: expandedRowKeys.add(revision);
		setExpandedRowKeys(new Set(expandedRowKeys));
	};

	const onExpandIconClick = (revision) => {
		toggleExpandByRevision(revision);
	};

	const onExpand = (expanded, record) => {
		toggleExpandByRevision(record.revision);
	};

	const revisionColumns = [
		{
			title: 'Title',
			render: (record) => {
				const submittedContact = getInvoiceSubmittedContact(record);
				const submittedTime = getInvoiceSubmittedAt(record);

				return (
					<Col>
						<Row>
							<h5 style={{ fontWeight: 500, marginBottom: 4 }}>
								Revision {nullSafeGet('revision', record)}
							</h5>
						</Row>
						<Row>
							<span>Submitted</span>
							{submittedTime ? (
								<span style={{ marginLeft: 4 }}>
									<DateTimeHover timestamp={submittedTime} />
								</span>
							) : null}
							{submittedContact
								? [
										<span style={{ marginRight: 4, marginLeft: 4 }}>by</span>,
										<UserName contact={submittedContact} mode={'inline'} />,
								  ]
								: null}
						</Row>
					</Col>
				);
			},
		},
		{
			title: 'Amount',
			render: (record) => {
				const isExpanded = expandedRowKeys.has(record.revision);
				return (
					<h5
						style={{
							display: 'flex',
							justifyContent: 'right',
							alignItems: 'baseline',
							marginBottom: 0,
						}}
					>
						<CustomCurrencyDisplay
							value={nullSafeGet('invoiceTotalAfterTax', record)}
							currency={getCurrency({ workOrder: nullSafeGet('workOrder', record) })}
							currencyStyle={{ fontSize: 16 }}
						/>
						<span style={{ marginLeft: 8, fontSize: 16 }}>
							{isExpanded ? <DownOutlined translate="" /> : <RightOutlined translate="" />}
						</span>
					</h5>
				);
			},
		},
	];

	const refreshInvoice = useCallback(() => {
		getInvoice(invoiceId).then((invoice) => {
			return invoice;
		});
	}, [invoiceId]);
	const expandRowRender = (record) => {
		return (
			<InvoicePageDisplay
				invoice={record}
				refreshInvoice={refreshInvoice}
				isDisplayOnly={true}
				cardWrapper={false}
			/>
		);
	};

	return (
		<Content className="invoicesDetailRevisionsPage" key={nullSafeGet('id', invoice)}>
			<Row gutter={12} style={{ margin: '16px 8px' }}>
				<Col span={24}>
					<Card>
						<Table
							expandIconColumnIndex={-1}
							showHeader={false}
							pagination={false}
							//loading={loading}
							columns={revisionColumns}
							rowKey={(el) => el.revision}
							dataSource={invoiceItems}
							expandedRowKeys={expandedRowKeys as any}
							onExpand={onExpand}
							expandedRowRender={expandRowRender}
							onRow={onRowWithRangeSelection((record, i) => ({
								onClick: (event) => onExpandIconClick(record.revision),
							}))}
						/>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	invoicesFetching: state.invoices.fetching,
	invoice: getEntityById(ownProps.match.params.id, state.invoices),
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getInvoice: (id) =>
		dispatch(
			getInvoiceRestCrudThunksFromPath(ownProps.userType, ownProps.history.location).readOne(id)
		),
});

export default withUserType(
	connect(mapStateToProps, mapDispatchToProps)(InvoiceDetailRevisionsPage)
);
